import Stack from "@mui/material/Stack";
import { BodyTextM, cs } from "@repo/ui";
import { type FC } from "react";
import Attention from "../../../components/AttentionBlock";
import { InternalLink } from "../../../components/Link";
import { Seo } from "../../../components/SEO";
import withProtection from "../../../highOrderComponents/withProtection";

const GDPR_URL = "https://www.nn.cz/ochrana-osobnich-udaju";

export const Title = (): string => cs.profile.communicationContractation.header;

const Info: FC = () => {
	return (
		<>
			<Stack spacing={4}>
				<BodyTextM>{cs.firstLogin.communicationContractationParagraph1}</BodyTextM>
				<BodyTextM>{cs.firstLogin.communicationContractationParagraph2}</BodyTextM>
				<BodyTextM>
					{cs.firstLogin.communicationContractationGdprPrefix}{" "}
					<InternalLink to={GDPR_URL} target="_blank" rel="noreferrer noopener">
						{cs.firstLogin.communicationContractationGdprLinkText}
					</InternalLink>
					.
				</BodyTextM>
			</Stack>
			<Attention severity="info" title={cs.profile.communicationContractation.blue.title}>
				<span
					dangerouslySetInnerHTML={{ __html: cs.profile.communicationContractation.blue.content }}
				/>
			</Attention>
		</>
	);
};


export const Head: FC = () => (
	<Seo title={Title()}>
		<meta name="robots" content="noindex" />
	</Seo>
);

export default withProtection(Info);
